export enum TransactionViewState {
  LIST = "LIST",
  DETAILS = "DETAILS",
  FILTERS = "FILTERS",
}
